module.exports = __webpack_public_path__ + "img/top.b947b5b5.png";